<template>
  <v-container fluid>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <h3 class="pa-3">{{$t('message.user.profile')}}</h3>
    </v-row>
    <v-divider></v-divider>
    <v-row>
    <v-col cols="12" md="3" lg="2" sm="3" v-if="!fieldsLoading">
      <v-img height="250" contain :src=" image.filepath ? `${getURL}/${image.filepath}` : require('../../assets/logo.png')">
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col class="py-1 text-right" @click='pickFiles' v-model='attachmentsList'>
             <v-btn right fab dark small color="cyan">
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
            <input type="file" id="image_attachment" name="image_attachment" accept="image/*" style="display: none" @change="getFile" ref="attachments">
          </v-col>
        </v-row>
      </v-img>
    </v-col>
    <v-col cols="12" md="9" lg="10" sm="9" v-if="!fieldsLoading">
      <v-form ref="userProfileForm">
        <v-row>
          <v-flex lg6 sm6 px-2>
          <v-text-field outlined :label="$t('message.user.firstName')" :rules="$_requiredValidation" v-model="userObj.firstname"></v-text-field>
          </v-flex>
          <v-flex lg6 sm6 px-2>
            <v-text-field outlined :label="$t('message.user.lastName')" v-model="userObj.lastname"></v-text-field>
          </v-flex>
          <v-flex lg6 sm6 px-2>
            <v-text-field outlined :label="$t('message.login.userName')" :rules="$_requiredValidation" v-model="userObj.username"></v-text-field>
          </v-flex>
          <v-flex lg6 sm6 px-2>
            <v-text-field outlined :label="$t('message.user.email')"  v-model="userObj.email"></v-text-field>
          </v-flex>
          <v-flex lg6 sm6 px-2>
          <v-text-field outlined :label="$t('message.user.mobile')" v-model="userObj.phone" ></v-text-field>
          </v-flex>
          <v-flex lg6 sm6 px-2></v-flex>
          <v-flex lg6 sm6 px-2 v-if="isNotUsingTicketSignature">
              <label>{{$t('message.user.signature')}}:</label>
              <VueSignaturePad width="100%" height="250px" class="signature--pad" ref="signaturePad"/>
          </v-flex>
          <v-flex lg6 md6 sm12 px-2 mt-3>
            <h4 class="pt-2">{{ $t('message.tickets.signature') }}</h4>
            <v-row>
              <v-col lg="6">
                <div contenteditable="true" class="ticket-signature-div" id="profilesignature"></div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab color="info" x-small @click="clearSignature" class="mt-2 float-right mr-12"  v-bind="attrs" v-on="on">
                      <v-icon>mdi-notification-clear-all</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('message.common.reset') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-flex>
          <v-flex lg6 sm6 px-2 mt-3 v-if="isNotUsingTicketSignature">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
              <v-btn color="info" fab small dark v-on="on" @click="undoThisSignature()" class="mr-4">
                <v-icon>mdi-undo</v-icon>
              </v-btn>
              </template>
              <span>Undo</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
              <v-btn color="warning" fab small dark v-on="on" @click="clearThisSignature()">
                <v-icon>clear</v-icon>
              </v-btn>
              </template>
              <span>Clear</span>
            </v-tooltip>
          </v-flex>
        </v-row>
      </v-form>
    </v-col>
    </v-row>
  <v-divider class="mt-4"></v-divider>
  <v-flex mt-2 class="text-center">
    <v-btn class="mr-4" color="primary" @click="saveUpdateHandler">Update</v-btn>
  </v-flex>
  </v-container>
</template>
<script>
import VueSignaturePad from 'vue-signature-pad'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      valid: true,
      fieldsLoading: false,
      userObj: { id: this.$store.state.userDetails.id },
      attachmentsList: [],
      // image:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcR2569aJKO0b0Vgo0MeWgx6BbKwmHBbZX9a2LEz2oOu55wUQjdR',
      image: {
        id: 0,
        filepath: ''
      },
      isNotUsingTicketSignature: false // make it true if not using ticket signature
    }
  },
  components: {
    VueSignaturePad
  },
  computed: {
    ...mapState([]),
    getURL () {
      let url = process.env.VUE_APP_URL
      return url.split('/api')[0]
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    if (this.userObj.id) this.getSingleRecordHandler()
  },
  methods: {
    undoThisSignature () {
      var self = this
      self.$refs.signaturePad.undoSignature()
    },
    onResize (event) {
      if (this.$refs.signaturePad) this.$refs.signaturePad.fromDataURL(this.userObj.signature)
    },
    clearThisSignature () {
      var self = this
      self.$refs.signaturePad.clearSignature()
    },
    getSingleRecordHandler () {
      this.$_getSingleRecordHandler(`users/${this.userObj.id}`).then((result) => {
        if (result.data) this.userObj = result.data
        if (!this.userObj.signature) this.userObj.signature = ''
        document.getElementById('profilesignature').innerHTML = `${this.userObj.signature}`
        this.$_getSingleRecordHandler(`userimages/get_by_user/${this.userObj.id}`).then((response) => {
          this.image = response.data
        })
      }).finally(() => {
        if (this.$refs.signaturePad) this.$refs.signaturePad.fromDataURL(this.userObj.signature)
      })
    },
    pickFiles () {
      this.$refs.attachments.click()
    },
    getFile () {
      var filesList = document.querySelector('#image_attachment')
      var formData = new FormData()
      if (filesList.files != null && filesList.files.length > 0) {
        for (let i = 0; i < filesList.files.length; i++) {
          formData.append(filesList.files[i].name, filesList.files[i])
        }
        this.$_executeApi('post', `userimages/upload/${this.userObj.id}`, formData).then(response => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'Image Uploaded Sucessfully' })
          this.image = response.data
        })
      }
    },
    saveUpdateHandler () {
      // let { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (this.$refs.userProfileForm.validate()) {
        this.loading = true
        let model = this.userObj
        let url = 'users'
        // if (isEmpty) model.signature = ''
        // else model.signature = data
        var contenteditable = document.querySelector('[contenteditable]')
        let content = contenteditable ? contenteditable.innerHTML : ''
        if (!model.signature && content) {
          content = `<div class="user-sign">${content}</div>`
        }
        model.signature = content
        this.$_saveUpdateHandler(url, model).finally(() => {
          this.loading = false
        })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    clearSignature () {
      document.getElementById('profilesignature').innerHTML = ''
    }
  },
  updated () {
    document.getElementById('profilesignature').innerHTML = this.userObj.signature ? this.userObj.signature : ''
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
<style scoped>
[contenteditable] {
  outline: 0px solid transparent;
}
.ticket-signature-div {
  width: 700px;
  border: 3px solid #cccccc;
  padding: 5px;
  min-height: 200px;
}
</style>
